import { NavItemBase, NAV_ITEM_TYPE, NavItemType } from './nav-item-base';

export class NavGroup extends NavItemBase {
  groupSegment: string;
  children: Array<NavItemType> = [];

  get url(): string {
    return this.segmentPath().join('/');
  }

  constructor(parent?: NavGroup) {
    super(NAV_ITEM_TYPE.Group, parent);
  }

  sort(deep: boolean = true): NavGroup {
    let ordinals: Array<NavItemType> = [];
    let children: Array<NavItemType> = [];

    for (let i = 0; i < this.children.length; i++) {
      let child = this.children[i];

      if (deep && NavGroup.IS_NAV_GROUP(child)) {
        child = child.sort(deep);
      }

      if (child.hasOrdinal) {
        ordinals.push(child);
      } else {
        children.push(child);
      }
    }

    ordinals.sort((a, b) => (a.ordinal > b.ordinal ? 1 : a.ordinal < b.ordinal ? -1 : 0));

    ordinals.forEach((o) => {
      if (o.ordinal <= children.length) {
        children.splice(o.ordinal, 0, o);
      } else {
        children.push(o);
      }
    });

    const ng = new NavGroup(this.parent as any);
    ng.groupSegment = this.groupSegment;
    ng.label = this.label;
    ng.breadcrumbLabel = this.breadcrumbLabel;
    ng.icon = this.icon;
    ng.ordinal = this.ordinal;
    ng.children = children;
    return ng;
  }

  private segmentPath(): string[] {
    let group: NavGroup = this;
    let path = [];
    do {
      if (group.groupSegment) {
        path.unshift(group.groupSegment);
      }
      group = <any>group.parent;
    } while (group);

    return path;
  }

  static IS_NAV_GROUP(item: NavItemType): item is NavGroup {
    return item && item.type === NAV_ITEM_TYPE.Group;
  }

  static createFrom(obj: Partial<NavGroup>, parent?: NavGroup): NavGroup {
    const navGroup = new NavGroup(parent);
    Object.assign(navGroup, obj);
    return navGroup;
  }
}
